interface BaseFaqDocument {
  id: string;
  itemId: string;
  name: string;
  data: string;
  userId: string;
  visibilityType: string | null;
  reminderDate: string | null;
  ticketNumber: string | null;
  createdOn: string;
  createdBy: string;
  attachment: string | null;
  docAvailableSuitelevel: boolean;
  isImportantDocument: boolean;
  isSuiteWarrantyStartDate: boolean;
  time: string | null;
  itemType: string | null;
  itemName: string | null;
  faqType: string | null;
  repeatType: string | null;
  repeatEvery: number;
  repeatTypeEvery: string | null;
  toggle: boolean;
  maintenanceReminderFrom: string | null;
  isNoteVisible: boolean;
  noteVisibleToHomeownerOccupantRealtor: boolean;
}

// Standard FAQ structure.
export interface Faq extends BaseFaqDocument {
  type: string[]; // For normal FAQs, this can be an array of like: ["Heating/Cooling", "Electrical", "Finishing", "Plumbing", "Exteriors"] etc
  question: string;
  answer: string;
  Embed: string | null;
  issue?: string;
  linkTitle?: string;
  caption?: string;
  image?: any;
  uploadType?: string;
}

// MAINTENANCEGUIDE structure.
export interface MaintenanceGuide extends BaseFaqDocument {
  type: 'MAINTENANCEGUIDE'; // For FAQs that are MaintenanceGuides, this will always be this.
  title: string;
  body: string;
  author: {
    id: string;
    firstName: string;
    lastName: string;
  };
  createdAt: string;
}

export type FaqDocument = Faq | MaintenanceGuide;

export const isMaintenanceGuide = (
  doc: FaqDocument
): doc is MaintenanceGuide => {
  return doc.name === 'MAINTENANCEGUIDE';
};

export const isFaq = (doc: FaqDocument): doc is Faq => {
  return doc.name === 'Frequently Asked Questions';
};

export const getDisplayQuestion = (doc: FaqDocument): string => {
  if (isMaintenanceGuide(doc)) {
    return doc.title || '';
  }

  return doc.question || '';
};

export const getDisplayAnswer = (doc: FaqDocument): string => {
  if (isMaintenanceGuide(doc)) {
    return doc.body || '';
  }

  return doc.answer || '';
};
